// extracted by mini-css-extract-plugin
export default {"main":"privacy_main__o2KGr","container":"privacy_container__iKPLB"};